var DeliveryMethod;
(function(DeliveryMethod) {
    DeliveryMethod["Delivery"] = 'home-delivery';
    DeliveryMethod["DeliveryExpress"] = 'home-delivery-express';
    DeliveryMethod["NearestPickup"] = 'nearest-pick-up';
    DeliveryMethod["Pickup"] = 'pick-up';
    DeliveryMethod["PickupPoint"] = 'pick-up-point';
    DeliveryMethod["DeliveryPremium"] = 'dpd-priority-delivery';
})(DeliveryMethod || (DeliveryMethod = {}));
var MultiBancoFields;
(function(MultiBancoFields) {
    MultiBancoFields["externalId"] = 'paymentExternalId';
    MultiBancoFields["externalReference"] = 'paymentExternalReference';
})(MultiBancoFields || (MultiBancoFields = {}));

export { DeliveryMethod, MultiBancoFields };
//# sourceMappingURL=details-order.js.map
